import { useState } from 'react';

export const useToggleExpand = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => setIsExpanded(!isExpanded);

  return [isExpanded, toggle];
};
